import getClient from './http-common'
import { getIsAuthorized } from './AccountProvider'
import { useQuery } from 'react-query'

const getInvoices = () => getClient().get('/v2/invoices/me')

export const useInvoiceQuery = () => {
    const query = useQuery('invoices', getInvoices, {
        enabled: getIsAuthorized(),
        retry: 0,
        refetchInterval: 900000,
    })
    return { ...query, data: query.data?.data }
}